import { render, staticRenderFns } from "./Start_call.vue?vue&type=template&id=3b2a2a06&scoped=true"
import script from "./Start_call.vue?vue&type=script&lang=js"
export * from "./Start_call.vue?vue&type=script&lang=js"
import style0 from "./Start_call.vue?vue&type=style&index=0&id=3b2a2a06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2a2a06",
  null
  
)

export default component.exports